import { Node, Edge } from '@xyflow/react';
import { AllFlowNodes } from '../Nodes/types';
import { InvalidNodeResponse } from '../customHooks/useValidationLogic';

type ValidateFn = (
  node: Node,
  nodes: Node[],
  edges: Edge[],
) => InvalidNodeResponse;

// Utility function to update a node's data and re-validate it
// Used in the LogicEditor component to update node data from the settings sidebar and re-validate it
export function updateNodeData(
  nodeId: string,
  newData: Partial<AllFlowNodes['data']>,
  currentNodes: Node[],
  edges: Edge[],
  validateNodeOptions: ValidateFn,
): Node[] {
  return currentNodes.map((node) => {
    if (node.id !== nodeId) return node;

    const updatedData = { ...node.data, ...newData };
    const isValid = validateNodeOptions(
      { ...node, data: updatedData },
      currentNodes,
      edges,
    );

    return {
      ...node,
      data: { ...updatedData, isValid },
    };
  });
}
